let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("eNmuD"), load("kfXhT"), load("2Lfdl"), load("dsiAd"), load("2vt1O")]).then(() => parcelRequire('3sora'));